export enum InsightsPageTabsEnum {
  Analytics = 'analytics',
  Advanced = 'advanced',
  AssistedRevenue = 'assistedRevenue',
  UnifiedAiInsights = 'unifiedAiInsights',
  KBSources = 'kbSources',
  ManageTopics = 'manageTopics',
  ManageAlerts = 'manageAlerts',
  ConversationRating = 'conversationRating',
}
